import { render, staticRenderFns } from "./SupportiveInformationSection.vue?vue&type=template&id=312facf4&scoped=true"
import script from "./SupportiveInformationSection.vue?vue&type=script&lang=js"
export * from "./SupportiveInformationSection.vue?vue&type=script&lang=js"
import style0 from "./SupportiveInformationSection.vue?vue&type=style&index=0&id=312facf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312facf4",
  null
  
)

export default component.exports